import PropTypes from 'prop-types';
import React from 'react';
import { Avatar, Badge } from '@ublend-npm/aulaui-core';
import StyledTooltip from '../common/StyledTooltip';

const ConversationParticipant = ({ name, avatar, online }) => {
  // Generate consistent avatar configuration using the name
  const avatarElement = (
    <Avatar
      aria-label="avatar"
      kind="circular"
      sizes="20px"
      src={avatar || ''}
      fallbackText={name?.substring(0, 1).toUpperCase()}
      sx={{
        color: '#fff',
        backgroundColor: '#5B516C',
      }}
    />
  );

  const avatarWithBadge = online ? (
    <Badge
      overlap="circular"
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      variant="dot"
      sx={{
        '& .MuiBadge-badge': {
          backgroundColor: '#44b700',
          color: '#44b700',
          '&::after': {
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            borderRadius: '50%',
            animation: 'ripple 1.2s infinite ease-in-out',
            border: '1px solid currentColor',
            content: '""',
          },
        },
        '@keyframes ripple': {
          '0%': {
            transform: 'scale(.8)',
            opacity: 1,
          },
          '100%': {
            transform: 'scale(2.4)',
            opacity: 0,
          },
        },
      }}
    >
      {avatarElement}
    </Badge>
  ) : (
    avatarElement
  );

  return (
    <StyledTooltip title={name} position="bottom">
      <div>{avatarWithBadge}</div>
    </StyledTooltip>
  );
};

ConversationParticipant.propTypes = {
  name: PropTypes.string,
  participantId: PropTypes.string.isRequired,
  avatar: PropTypes.string,
  online: PropTypes.bool,
};

ConversationParticipant.defaultProps = {
  name: '',
  avatar: null,
  online: false,
};

export default ConversationParticipant;
